var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"neutral700--text text-sm font-semibold mb-3"},[_vm._v("Are you sure you want to redeem this offer?")]),_c('redeem-offer-one-item',{attrs:{"offer":_vm.offer}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }